var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.file.preview",
  title: "File Preview Element",
  description: "Preview file URIs while respecting secured routes.",
  supportServer: false,
  fields: {
    uri: { title: "URI", type: ["uri", "list"], description: "File URI (or URI list) to preview.", required: true },
    mimeType: { title: "MIME Type", type: "string", description: "Optional MIME type hint." },
    title: { title: "Title", type: "string", description: "Optional file title." },
    height: { title: "Height", type: "string", description: "Preview height.", default: "12rem" }
  }
});

var jsonRender = require("../interface/jsonRender.js");

function lower(value) {
  return (value || "").toString().trim().toLowerCase();
}

function toArray(value) {
  if (!(value)) return [];
  if (value instanceof Array) return value.slice();
  return [value];
}

function inferByUri(uri) {
  var u = lower(uri);
  if (u.match(/\.(png|jpg|jpeg|gif|webp|bmp)(\?|#|$)/i)) return "image";
  if (u.match(/\.(mp4|webm|ogg|mov)(\?|#|$)/i)) return "video";
  if (u.match(/\.(mp3|wav|m4a|aac|oga)(\?|#|$)/i)) return "audio";
  if (u.match(/\.pdf(\?|#|$)/i)) return "pdf";
  return "other";
}

function resolveProviderUri(uri) {
  var raw = (uri || "").toString().trim();
  if (!(raw)) return "";
  if (raw.match(/^https?:\/\//i)) return raw;

  if (raw.match(/^dropbox:\/\//i)) {
    var payload = raw.replace(/^dropbox:\/\//i, "");
    if (payload.match(/^https?:\/\//i)) return payload;
    if (payload.startsWith("s/")) return "https://www.dropbox.com/" + payload;
    return "https://www.dropbox.com/home/" + payload.replace(/^\/+/, "");
  }
  if (raw.match(/^gdrive:\/\//i)) {
    var g = raw.replace(/^gdrive:\/\//i, "");
    if (g.match(/^https?:\/\//i)) return g;
    if (g.match(/^[a-zA-Z0-9_-]{10,}$/)) return "https://drive.google.com/file/d/" + g + "/view";
    return "https://drive.google.com/drive/my-drive";
  }
  if (raw.match(/^s3:\/\//i)) {
    var s3 = raw.replace(/^s3:\/\//i, "");
    var firstSlash = s3.indexOf("/");
    if (firstSlash > 0) {
      var bucket = s3.slice(0, firstSlash);
      var key = s3.slice(firstSlash + 1);
      return "https://" + bucket + ".s3.amazonaws.com/" + key;
    }
  }
  if (raw.match(/^provider:\/\//i)) return raw.replace(/^provider:\/\//i, "https://");
  return raw;
}

exports.render = async function(options) {
  var uris = toArray(options.uri).map(function(item) {
    return resolveProviderUri((item || "").toString().trim());
  }).filter(Boolean);
  var height = (options.height || "12rem").toString();
  var payload = {
    n: "div",
    c: "ua-file-preview border rounded p-2",
    i: []
  };

  if (uris.length === 0) {
    payload.i.push({ n: "div", c: "small text-muted", i: "No file selected." });
    return jsonRender.render(payload);
  }

  for (var i = 0; i < uris.length; i++) {
    var uri = uris[i];
    var mime = lower(options.mimeType || "");
    var kind = "other";

    if (mime.startsWith("image/")) kind = "image";
    else if (mime.startsWith("video/")) kind = "video";
    else if (mime.startsWith("audio/")) kind = "audio";
    else if (mime === "application/pdf") kind = "pdf";
    else kind = inferByUri(uri);

    if (i > 0) payload.i.push({ n: "hr", c: "my-2" });

    if (kind === "image") {
      payload.i.push({ n: "img", src: uri, alt: options.title || "File preview", class: "img-fluid rounded", style: "max-height: " + height + ";" });
    } else if (kind === "video") {
      payload.i.push({ n: "video", src: uri, controls: true, class: "w-100 rounded", style: "max-height: " + height + ";" });
    } else if (kind === "audio") {
      payload.i.push({ n: "audio", src: uri, controls: true, class: "w-100" });
    } else if (kind === "pdf") {
      payload.i.push({ n: "iframe", src: uri, class: "w-100 border-0 rounded", style: "height: " + height + ";" });
    } else {
      payload.i.push({ n: "a", href: uri, target: "_blank", rel: "noopener noreferrer", class: "btn btn-outline-primary btn-sm", i: [{ n: "i", c: "bi bi-box-arrow-up-right me-1" }, "Open File"] });
    }
  }

  return jsonRender.render(payload);
};
